var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 18,
    viewBox: "0 0 5 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.27637 10.2171C2.79535 10.2171 3.21607 9.79633 3.21607 9.27735C3.21607 8.75837 2.79535 8.33766 2.27637 8.33766C1.75739 8.33766 1.33667 8.75837 1.33667 9.27735C1.33667 9.79633 1.75739 10.2171 2.27637 10.2171Z",
    stroke: "#131313",
    strokeOpacity: 0.7,
    strokeWidth: 1.8794,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.27637 3.63916C2.79535 3.63916 3.21607 3.21845 3.21607 2.69946C3.21607 2.18048 2.79535 1.75977 2.27637 1.75977C1.75739 1.75977 1.33667 2.18048 1.33667 2.69946C1.33667 3.21845 1.75739 3.63916 2.27637 3.63916Z",
    stroke: "#131313",
    strokeOpacity: 0.7,
    strokeWidth: 1.8794,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.27637 16.7949C2.79535 16.7949 3.21607 16.3742 3.21607 15.8552C3.21607 15.3363 2.79535 14.9155 2.27637 14.9155C1.75739 14.9155 1.33667 15.3363 1.33667 15.8552C1.33667 16.3742 1.75739 16.7949 2.27637 16.7949Z",
    stroke: "#131313",
    strokeOpacity: 0.7,
    strokeWidth: 1.8794,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableIcons);
export default __webpack_public_path__ + "static/media/table-icons.59e7e05694468e980d742f30bf0c4cda.svg";
export { ForwardRef as ReactComponent };